export enum AuthenticationType {
  Password = 0,
  Sso = 1,
  UserApiKey = 2,
  AuthRequest = 3,
  WebAuthn = 4,
}
